var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanAirlinesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17431_5777)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    transform: "translate(3 3)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7582 33.4819L25.5779 41.4909C27.0719 43.8912 29.5333 44.9805 32.6001 44.9805H44.9997L30.4834 27.3893L28.4239 26.2166L22.9892 27.99L20.2354 31.9751L20.7582 33.4819Z",
    fill: "url(#paint0_linear_17431_5777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4837 27.3897L27.4533 23.7163L19.4438 28.0244L20.2933 32.3729L20.7584 33.4823C20.5763 30.5351 25.6365 27.1133 30.4837 27.3897Z",
    fill: "url(#paint1_linear_17431_5777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7582 33.4817L16.4248 26.3165C15.9028 25.5036 15.7598 24.7924 15.7598 23.9638C15.7598 23.0524 16.1483 22.5527 17.6405 21.7613C19.3787 20.9291 22.8784 20.5671 26.4861 20.5671C32.3483 20.5671 33.7536 22.4485 34.3521 24.4787C34.3521 24.4787 33.5244 24.1497 31.5776 24.1497C25.4017 24.1497 20.4651 27.1476 20.4651 31.6868C20.4651 32.6393 20.7582 33.4817 20.7582 33.4817Z",
    fill: "url(#paint2_linear_17431_5777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14551 3H7.97447C10.4327 3 11.4409 4.00561 12.4354 4.99224C13.5736 6.02692 17.0256 10.699 24.3231 19.8177H16.4249C13.1952 19.8177 12.1737 19.2675 10.9246 17.3626L2.14551 3Z",
    fill: "url(#paint3_linear_17431_5777)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17431_5777",
    x1: 20.2253,
    y1: 27.543,
    x2: 20.2253,
    y2: 44.9365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB2023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#E92026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E31E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2986,
    stopColor: "#E01E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    stopColor: "#D81F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CF2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C62127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B92025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#AE1F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A01D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#901C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17431_5777",
    x1: 20.7081,
    y1: 33.4535,
    x2: 30.3724,
    y2: 27.2644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#7F2620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4983,
    stopColor: "#982B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    stopColor: "#B53125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB3327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17431_5777",
    x1: 19.9493,
    y1: 31.7858,
    x2: 34.1073,
    y2: 23.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#DFE4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4983,
    stopColor: "#CAD1D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    stopColor: "#A8B5BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93A6AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17431_5777",
    x1: 11.9196,
    y1: 3.00505,
    x2: 11.9196,
    y2: 19.8083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05AEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#00A9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#07A3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2986,
    stopColor: "#089DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    stopColor: "#0A92CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0F87C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#127CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0E70AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0F63A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#135393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184485"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17431_5777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanAirlinesIcon);
export default __webpack_public_path__ + "static/media/american-airlines-icon.764b6c7d43e424536899c427a51d72f9.svg";
export { ForwardRef as ReactComponent };